import { render } from "./PrepareNewSemesterModalForm.vue?vue&type=template&id=5f313ed0"
import script from "./PrepareNewSemesterModalForm.vue?vue&type=script&lang=js"
export * from "./PrepareNewSemesterModalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__